module.exports = __webpack_public_path__ + "img/swipe2.8a4cf6e3.png";